import React, { useState } from "react";
import styled from "styled-components";

interface AnimatedInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const InputWrapper = styled.div`
  position: relative;
  margin-top: 20px;
`;

const InputField = styled.input`
  appearance: none;
  border: solid 1px rgb(220, 220, 220);
  box-sizing: border-box;
  flex: 1 1 auto;
  font-size: 14px;
  display: block;
  padding: 10px;
  outline: none;
  width: 100%;
  background-color: transparent;

  &::placeholder {
    color: transparent;
    transition: all 0.3s ease-in-out;
    transform-origin: top left;
    font-size: 14px;
  }

  &:focus {
    &::placeholder {
      transform: translateY(-110%) scale(0.8);
      color: #999;
    }
  }
`;

const Label = styled.label<{ focused: boolean }>`
  position: absolute;
  top: ${({ focused }) => (focused ? "-15px" : "10px")};
  left: ${({ focused }) => (focused ? "-1px" : "10px")};
  font-size: ${({ focused }) => (focused ? "12px" : "14px")};
  color: ${({ focused }) => (focused ? "#999" : "#605F5F")};
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  user-select: none;
  background-color: "rgb(242, 244, 246)";
  font-family: "Fira Sans", sans-serif;
`;

const AnimatedInput: React.FC<AnimatedInputProps> = ({
  label,
  defaultValue,
  ...props
}) => {
  const [focused, setFocused] = useState(!!props.value || !!defaultValue);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(!!props.value || !!defaultValue);
  };

  return (
    <InputWrapper>
      <Label htmlFor={props.id || props.name} focused={focused}>
        {label}
      </Label>
      <InputField
        name="first_name"
        autoComplete="name"
        {...props}
        defaultValue={defaultValue}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </InputWrapper>
  );
};

export default AnimatedInput;
